export interface IAPIResponse {
  message: string;
  success: boolean;
  data: any;
}

export enum HeaderTypes {
  MAIN_HEADER = "MAIN_HEADER",
  PAYMENT_HEADER = "PAYMENT_HEADER",
  PAYMENT_HEADER_INVOICE = "PAYMENT_HEADER_INVOICE"
}

export const ErrorResponseTypes = {
  INVALID_KEY: "INVALID_KEY",
  LIMIT_REACHED: "LIMIT_REACHED",
};

export const SuccessMessages = {
  WEBINAR_REGISTERED: "Webinar Registered successfully.",
  REVIEW_ADDED_SUCCESSFULLY: "Review submitted successfully!",
};

export const ErrorMessages = {
  INVALID_KEY_ERROR_MESSAGE:
    "Key is invalid please recheck and make sure key is correct.",
  LIMIT_REACHED_ERROR_MESSAGE:
    "This key has reached maximum usage limit. Please try with different key.",
};

export interface ILearningCard {
  event_id: number;
  event_status: string;
  event_banner: string;
  author_list: AuthorList[];
  author_learning_title: string;
  title: string;
  price: number;
  status: string;
}

export interface AuthorList {
  id: number;
  order: number;
  name: string;
  image: string;
}

export interface IDashboardBanner {
  banner_name: string;
  event_id: number;
  event_url: string;
  image_url: string;
  is_live: number;
  category_name: any;
}
export interface IDashboardPastEvent {
  event_id?: number;
  event_name?: string;
  category_id?: number;
  category_name?: string;
  practice_id?: number;
  practice_name?: string;
  is_featured?: number;
  level_id?: number;
  focus_area?: any[];
  url?: string;
  description?: string;
  webinar_agenda?: any;
  webinar_benefits?: any;
  type?: string;
  SessionDates?: string;
  TotalSessions?: number;
  speaker_details?: SpeakerDetail[];
  event_image?: string;
  event_thumbnail_url?: any;
  event_status?: number;
  earliest_session_date?: string;
}
export interface SpeakerDetail {
  name: string;
  image: any;
  order: any;
}
export interface IPracticeArea {
  practice_area_id: number;
  practice_area_name: string;
  thumbnail_video_url: string;
}
export interface IRecommended {
  event_id: number;
  event_name: string;
  session_id: any;
  description: string;
  category_name: string;
  hero_banner: string;
  speakers: Speaker[];
  earliest_session_datetime: any;
}

export interface Speaker {
  speaker_name: string;
  speaker_image: string;
}

export interface IPracticeResult {
  id: number;
  name: string;
  speaker?: IPracticeSpeaker[];
  category: IPracticeCategory;
  practice_area: IPracticePracticeArea;
  level: IPracticeLevel;
  focus_area?: IPracticeFocusArea[];
  start_date?: string;
  end_date?: string;
  event_image?: string;
  description: string;
  created_at: string;
}
export interface IPracticeSpeaker {
  id: number;
  firm: string;
  name: string;
  image: any;
}

export interface IPracticeCategory {
  id: number;
  name: string;
}

export interface IPracticePracticeArea {
  id: number;
  name: string;
}

export interface IPracticeLevel {
  id: number;
  name: string;
}

export interface IPracticeFocusArea {
  id: number;
  name: string;
}
